import LexusPartnerSvg from 'src/assets/images/lexus-partner.svg';
import styled from 'styled-components';

export const LexusPartner = styled(LexusPartnerSvg)`
  height: 1.5rem;
`;
